'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiChartPie = function TiChartPie(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.4 23.3l8.1 8.2c0.7 0.7 1.7 0.6 2.2-0.2 1.4-2.3 2.3-5 2.3-8 0-3.5-1.2-6.8-3.3-9.4l-9.3 9.4z m-4.4 0.7v-12.3c-5.7 0.8-10 5.7-10 11.6 0 6.5 5.2 11.7 11.7 11.7 2.6 0 5-0.9 6.9-2.3l-8.6-8.7z m12.2-13.6c0.7-0.7 0.6-1.7-0.1-2.2-2.1-1.5-4.5-2.5-7.1-3-0.9-0.1-1.7 0.5-1.7 1.5v12.6l8.9-8.9z' })
        )
    );
};

exports.default = TiChartPie;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/chart-pie.js
// module id = 2009
// module chunks = 0